import { apiRequest } from './client';

/** Guided tour flag (SRS #39). */
const opts = (extra: RequestInit = {}): RequestInit => {
  const token = localStorage.getItem('policyora_token');
  return { ...extra, headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(extra.headers || {}) } };
};
export const completeTour = () => apiRequest<{ tour_completed_at: string | null }>('/api/v1/users/tour/complete', opts({ method: 'POST' }));
export const resetTour = () => apiRequest<{ tour_completed_at: string | null }>('/api/v1/users/tour/reset', opts({ method: 'POST' }));
